import fetch from 'lib/request'
import ms from 'ms'
import { APP_VERSION } from '../config'

let latestCheck = { version: APP_VERSION }
const pageLoadTime = Date.now()

async function check() {
  latestCheck = await fetch('/__meta__.json').then(res => res.json())
}

export function isOnLatest() {
  return latestCheck.version === APP_VERSION
}

/*
  Periodically check for what's the latest version of App.
  This will allow us to do a hard refresh of the page in case the app gets out of sync,
  guaranteeing that we'll always have the latest version available on nagivation.
*/
setInterval(async () => {
  try {
    await check()

    // Forcibly reload the page if app is out of date and it hasn't been
    // reloaded for over 12 hours. This is to prevent errors from people that
    // just leave the app open in a tab for long periods of time.
    const currentTime = Date.now()
    const millisecondsSincePageLoad = currentTime - pageLoadTime
    if (!isOnLatest() && millisecondsSincePageLoad > ms('12h')) {
      window.location.reload()
    }
  } catch (e) {
    console.error(e)
  }
}, 20000)
